// Mock CRM data backing the RaiseTicket form. When the backend ticket
// model lands these arrays get replaced with API hooks. Shapes are
// deliberately the same so the swap is local to this file.
//
// Source: derived from the trustlab_crm_updated_18.html mock (the same
// ticket UI screenshot that drives RaiseTicket's design).

export const TICKET_BRANCHES = [
  'TL HYDERABAD TS',
  'TL SECUNDERABAD',
  'TL BENGALURU JP',
  'TL BENGALURU INDIRANAGAR',
  'TL CHENNAI NUNGAMBAKKAM',
  'TL MUMBAI ANDHERI',
  'TL PUNE KOTHRUD',
  'TL DELHI GURUGRAM',
  'TL KOLKATA SALT LAKE',
];

export const TICKET_DEPARTMENTS = [
  'STORE',
  'LAB',
  'OPERATIONS',
  'BILLING',
  'IT',
  'HR',
  'CUSTOMER SUPPORT',
  'QUALITY',
  'LOGISTICS',
];

// Three-level taxonomy: Issue Category → Sub-Category → Specific Issue.
// Matches what the screenshot's selected ticket shows
// ("Stock Required" → "Consumables stock required" → ditto) plus a few
// realistic adjacent options so each level has something to pick.
export const TICKET_CATEGORY_TREE = [
  {
    label: 'Stock Required',
    children: [
      {
        label: 'Consumables stock required',
        children: [
          { label: 'Consumables stock required' },
          { label: 'Vacutainers / blood collection tubes' },
          { label: 'Reagents nearing expiry' },
          { label: 'Sample transport bags' },
        ],
      },
      {
        label: 'Reagents stock required',
        children: [
          { label: 'Biochemistry reagent shortfall' },
          { label: 'Immunology reagent shortfall' },
          { label: 'Hematology reagent shortfall' },
        ],
      },
      {
        label: 'Stationery / printer supplies',
        children: [
          { label: 'Printer toner exhausted' },
          { label: 'Report stationery required' },
          { label: 'TRF forms required' },
        ],
      },
    ],
  },
  {
    label: 'Equipment Issue',
    children: [
      {
        label: 'Analyzer not working',
        children: [
          { label: 'Biochemistry analyzer down' },
          { label: 'Hematology analyzer down' },
          { label: 'Urine analyzer down' },
          { label: 'Coagulation analyzer down' },
        ],
      },
      {
        label: 'Calibration / QC failure',
        children: [
          { label: 'Repeated QC failure' },
          { label: 'Calibration drift detected' },
          { label: 'Reagent lot variation' },
        ],
      },
      {
        label: 'Equipment maintenance',
        children: [
          { label: 'Centrifuge maintenance due' },
          { label: 'UPS / power backup issue' },
          { label: 'Refrigeration / cold-chain alert' },
        ],
      },
    ],
  },
  {
    label: 'Sample / Logistics',
    children: [
      {
        label: 'Sample integrity',
        children: [
          { label: 'Sample hemolysed on arrival' },
          { label: 'Sample insufficient quantity' },
          { label: 'Sample container leaked' },
          { label: 'Sample mislabelled' },
        ],
      },
      {
        label: 'Pickup / drop schedule',
        children: [
          { label: 'Trustian no-show' },
          { label: 'Cold-chain transit delay' },
          { label: 'Sample not received at central lab' },
        ],
      },
    ],
  },
  {
    label: 'Reporting',
    children: [
      {
        label: 'Report delay',
        children: [
          { label: 'Report past committed TAT' },
          { label: 'Report stuck pending pathologist sign-off' },
          { label: 'Report not delivered to patient' },
        ],
      },
      {
        label: 'Report correction',
        children: [
          { label: 'Wrong patient name / age / gender' },
          { label: 'Wrong reference range' },
          { label: 'Re-issue with amendment note' },
        ],
      },
    ],
  },
  {
    label: 'Billing',
    children: [
      {
        label: 'Invoice / receipt issue',
        children: [
          { label: 'GST invoice required' },
          { label: 'Wrong amount on invoice' },
          { label: 'Refund pending' },
        ],
      },
      {
        label: 'Pricing / discount',
        children: [
          { label: 'Approved corporate rate not applied' },
          { label: 'Membership discount missing' },
          { label: 'Insurance / TPA mismatch' },
        ],
      },
    ],
  },
  {
    label: 'IT / Software',
    children: [
      {
        label: 'LIS / portal login',
        children: [
          { label: 'Cannot login to portal' },
          { label: 'Account locked' },
          { label: '2FA / OTP not received' },
        ],
      },
      {
        label: 'Connectivity',
        children: [
          { label: 'Internet down at branch' },
          { label: 'VPN / interfacing issue' },
          { label: 'Printer / scanner offline' },
        ],
      },
    ],
  },
  {
    label: 'HR / Staffing',
    children: [
      {
        label: 'Roster / leave',
        children: [
          { label: 'Phlebotomist shortfall today' },
          { label: 'Approved leave not reflected' },
          { label: 'Backfill required' },
        ],
      },
    ],
  },
  {
    label: 'Other',
    children: [
      {
        label: 'General request',
        children: [
          { label: 'General request' },
        ],
      },
    ],
  },
];

export const TICKET_PRIORITY_OPTIONS = [
  { value: 'critical', label: 'Critical' },
  { value: 'high',     label: 'High' },
  { value: 'normal',   label: 'Normal' },
  { value: 'low',      label: 'Low' },
];
